import { useState } from 'react'

import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { toast } from '@sales-center/components'
import { useCallback } from 'react'
import { updateSalesTeamPosition, createSalesTeamPosition } from '../api'
import {
  SalesTeamPositionCreateModel,
  SalesTeamPositionUpdateModel,
} from '@user/store/salesTeam/typings'

function isIPositionUpdateModel(
  model: SalesTeamPositionCreateModel | SalesTeamPositionUpdateModel,
): model is SalesTeamPositionUpdateModel {
  return (model as SalesTeamPositionUpdateModel).id !== undefined
}

export function useCreateUpdatePosition() {
  const dispatch = useAppDispatch()

  const [state, setState] = useState<{
    status: 'idle' | 'pending' | 'success' | 'fail'
    errors?: Map<string, string[]>
  }>(() => ({
    status: 'idle',
  }))

  const execute = useCallback(
    async (
      model: SalesTeamPositionCreateModel | SalesTeamPositionUpdateModel,
    ) => {
      const isUpdate = isIPositionUpdateModel(model)
      let success = false
      let result

      setState({ status: 'pending' })

      if (isUpdate) {
        result = await dispatch(updateSalesTeamPosition(model))
        if (updateSalesTeamPosition.fulfilled.match(result)) {
          success = true
        }
      } else {
        result = await dispatch(createSalesTeamPosition(model))
        if (createSalesTeamPosition.fulfilled.match(result)) {
          success = true
        }
      }

      if (success) {
        const msg = isUpdate ? 'updated' : 'created'
        toast.success(`Sales Team Position ${msg}`)
        setState({ status: 'success' })
      } else {
        setState(() => {
          if (result.payload) {
            const { errors, title } = result.payload

            toast.error(`Error: ${title}`)

            if (errors) {
              return {
                status: 'fail',
                errors: new Map(
                  Object.keys(errors).map((k) => [k.toLowerCase(), errors[k]]),
                ),
              }
            } else return { status: 'fail' }
          } else return { status: 'fail' }
        })
      }
    },
    [dispatch],
  )

  return { ...state, execute }
}
